<script>
import ActivityLabel from '@/js/components/activity/ActivityLabel';

export default {
    name: 'ActivitiesCountLabel',

    functional: true,

    props: {
        count: {
            type: [String, Number],
            required: true,
            validator: (value) => String(value) === 'all' || !isNaN(value),
        },
    },

    render(createElement, {props, data, parent}) {
        const count = props.count === 'all'
            ? parent.$t('activities.all')
            : parent.$tc('activities.count', props.count);

        data.props = {activity: {name: count}};

        return createElement(ActivityLabel, data);
    },
};
</script>
